module.exports = __webpack_public_path__ + "img/efca99d9758c06d9bb168d6797ba3242.svg";